import React, { useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Row from "./Row";
import Checkbox from "../../../components/Checkbox";

const Table = ({ 
  className, 
  items = [], 
  onFormationSelect, 
  selectedFormations = [],
  onSelectFormation,
  onSelectAll
}) => {
  const [activeId, setActiveId] = useState(null);
  
  // Calculer si tous les éléments sont sélectionnés
  const allSelected = items.length > 0 && items.every(item => selectedFormations.includes(item.id));

  const handleSelectAll = () => {
    if (onSelectAll) {
      onSelectAll(!allSelected);
    }
  };

  const handleSelectFormation = (id, isSelected) => {
    if (onSelectFormation) {
      onSelectFormation(id, isSelected);
    }
  };

  const handleFormationClick = (id) => {
    if (onFormationSelect) {
      onFormationSelect(id);
    }
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={cn(styles.row, styles.header)}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              checked={allSelected}
              onChange={handleSelectAll}
            />
          </div>
          <div className={styles.col}>Titre de qualification</div>
          <div className={styles.col}>Code RNCP</div>
          <div className={styles.col}>Code diplôme</div>
          <div className={styles.col}>Type de diplome</div>
          <div className={styles.col}>Statut</div>
        </div>
        {items.length > 0 ? (
          items.map((x, index) => (
            <Row
              item={x}
              key={index}
              activeId={activeId}
              setActiveId={setActiveId}
              value={selectedFormations.includes(x.id)}
              onChange={(isChecked) => handleSelectFormation(x.id, isChecked)}
              onClick={() => handleFormationClick(x.id)}
            />
          ))
        ) : (
          <div className={styles.noData}>Aucune donnée disponible</div>
        )}
      </div>

    </div>
  );
};

export default Table;
